module.exports = __webpack_public_path__ + "static/media/industry.ac3dc41a.svg";